import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function Input({
  className,
  inputClassName,
  placeholder,
  label,
  suffix,
  prefix,
  type,
  min,
  max,
  onChange,
  value,
  clearButton = false,
  size = "md",
  hasError,
  disabled,
  required,
}: {
  className?: string;
  inputClassName?: string;
  placeholder?: string;
  label?: string;
  suffix?: React.ReactNode;
  prefix?: React.ReactNode;
  clearButton?: boolean;
  type: string;
  min?: string;
  max?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  size?: "sm" | "md" | "lg";
  hasError?: boolean;
  disabled?: boolean;
  required?: boolean;
}) {
  const hasPrefix = prefix !== undefined;
  const hasSuffix = suffix !== undefined;
  let inputRoundnessClass = "";
  if (hasPrefix && !hasSuffix) {
    inputRoundnessClass = "rounded-r-md";
  } else if (!hasPrefix && hasSuffix) {
    inputRoundnessClass = "rounded-l-md";
  }

  return (
    <div className={`${className}`}>
      {label && (
        <label
          className={`block text-sm font-medium ${disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-500"}`}
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="flex">
        {prefix && (
          <div className="border-y-1 border-l-1 border-gray-300 rounded-l-lg bg-gray-200 px-3 flex items-center justify-center">
            {prefix}
          </div>
        )}
        <div className="relative grow">
          <input
            className={`w-full border-1 border-gray-300 ${inputRoundnessClass} p-2 bg-white disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed ${inputClassName} ${
              hasError
                ? "border-red-500"
                : "" +
                  " " +
                  (size === "sm"
                    ? "text-xs"
                    : size === "md"
                      ? "text-sm"
                      : "text-base")
            }`}
            disabled={disabled}
            max={max}
            min={min}
            placeholder={placeholder}
            type={type}
            value={value}
            onChange={onChange}
          />
          {clearButton && value !== "" && (
            <button
              className={`absolute ${type === "date" ? "right-8" : "right-2"} top-1/2 -translate-y-1/2 cursor-pointer`}
              type="button"
              onClick={() =>
                onChange?.({
                  target: { value: "" },
                } as React.ChangeEvent<HTMLInputElement>)
              }
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
        </div>
        {suffix && (
          <div className="border-y-1 border-r-1 border-gray-300 rounded-r-lg bg-gray-200 px-3 flex items-center justify-center">
            {suffix}
          </div>
        )}
      </div>
    </div>
  );
}
